import { Loader } from '@neo.tax/shared';

import { RdHomeLayout } from './organisms';

export const RdHome = (): React.ReactElement => (
  <Loader useRedirect={() => ({ isLoading: false })}>
    <RdHomeLayout />
  </Loader>
);
